


// AdminEditAreaPage - Manage species for a specific area
// HUVUDSAKLIG FUNKTION ÄR ATT LÄGGA TILL OCH TA BORT ARTER FRÅN ARTLISTAN FÖR EN UTVALD NATUROMRÅDE

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useGET from "../../services/useGET";
import NaturmarketImage from "../../assets/images/Naturmarket.png";
import { useLocation } from "react-router-dom";
import { getToken } from "../../services/tokenGET";
import AdminSidebar from "../../components/layout/AdminSidebar";

export default function AdminEditAreaPage() {
    const { data: species, isPending } = useGET(`${process.env.REACT_APP_API_URL}/species`);
    const [selectedSpecies, setSelectedSpecies] = useState([]);
    const [selectedAreaSpecies, setSelectedAreaSpecies] = useState([]);
    const [areaName, setAreaName] = useState("");
    const [areaId, setAreaId] = useState(null);
    const [areaSpecies, setAreaSpecies] = useState([]);
    const [speciesSearch, setSpeciesSearch] = useState(""); // State for species search in left list
    const [areaSpeciesSearch, setAreaSpeciesSearch] = useState(""); // State for species search in right list
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const queryAreaName = queryParams.get("area");
        const queryAreaId = queryParams.get("areaId");

        if (queryAreaName) {
            setAreaName(queryAreaName);
        }
        if (queryAreaId) {
            setAreaId(queryAreaId);
        }
    }, [location.search]);

    useEffect(() => {
        if (areaId) {
            fetch(`${process.env.REACT_APP_API_URL}/api/admin/area/${areaId}/species`)
                .then((response) => response.json())
                .then((data) => {
                    setAreaSpecies(data.species);
                })
                .catch((error) => console.error("Error fetching species:", error));
        }
    }, [areaId]);

    const handleSelectSpecies = (speciesItem) => {
        setSelectedAreaSpecies([]); // Clear selection from the other list
        setSelectedSpecies((prev) =>
            prev.includes(speciesItem)
                ? prev.filter((item) => item !== speciesItem) // Deselect if already selected
                : [...prev, speciesItem] // Select if not selected
        );
    };

    const handleSelectAreaSpecies = (speciesItem) => {
        setSelectedSpecies([]); // Clear selection from the other list
        setSelectedAreaSpecies((prev) =>
            prev.includes(speciesItem)
                ? prev.filter((item) => item !== speciesItem) // Deselect if already selected
                : [...prev, speciesItem] // Select if not selected
        );
    };

    const handleAddSpeciesToZone = async () => {
        if (!selectedSpecies.length) {
            console.warn("No species selected.");
            return; // Exit if no species are selected
        }
        const speciesIds = selectedSpecies.map(species => species.id);

        try {
            const token = await getToken(); // Ensure you are getting the token correctly
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/area/${areaId}/species`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": token,
                },
                body: JSON.stringify({
                    species_ids: speciesIds
                }),
            });

            // Check if the response is successful
            if (!response.ok) {
                await response.text(); // Read the response body as text for errors
                throw new Error("Failed to add species. Server responded with an error.");
            }

            // Check if the response is JSON
            const contentType = response.headers.get("Content-Type");
            if (contentType && contentType.includes("application/json")) {
                const data = await response.json(); // Parse JSON if it's valid
                
                // Update area species list
                setAreaSpecies((prev) => [...prev, ...selectedSpecies]);
                setSelectedSpecies([]); // Clear selection
            }
        } catch (error) {
            console.error("Error adding species:", error);
        }
    };

    const handleRemoveAllSpeciesFromZone = async () => {
        try {
            const token = await getToken();

            // Prepare an array of species IDs to remove
            const speciesIds = selectedAreaSpecies.map(species => species.id);

            if (speciesIds.length === 0) {
                // No species selected for removal
                return;
            }


            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/area/${areaId}/species`, {
                method: 'DELETE', // DELETE request for removing species
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    'X-CSRF-TOKEN': token,
                },
                body: JSON.stringify({ species_ids: speciesIds })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to remove species");
            }
            setAreaSpecies((prev) =>
                prev.filter(species => !speciesIds.includes(species.id))
            );


            setSelectedAreaSpecies([]);
            setSelectedSpecies([]);

        } catch (error) {
            console.error("Error removing species:", error);
        }
    };

    const filteredSpecies = species?.filter((x) => x.name.toLowerCase().includes(speciesSearch.toLowerCase()));
    const filteredAreaSpecies = areaSpecies?.filter((x) => x.name.toLowerCase().includes(areaSpeciesSearch.toLowerCase()));

    return (
        <div className="min-h-screen bg-offwhite">
            <AdminSidebar />
            
            {/* Main Content */}
            <div className="md:ml-64">
                {/* Header */}
                <div className="bg-leaf p-6 shadow-md">
                    <div className="flex items-center gap-4">
                        <img
                            src={NaturmarketImage}
                            alt="Naturmärket"
                            className="w-20 h-20 rounded-full"
                        />
                        <h1 className="font-heading text-3xl text-white">
                            Naturborgarmärket
                        </h1>
                    </div>
                </div>

                {/* Back Button */}
                <div className="p-6">
                    <Link
                        to="/admin-omraden"
                        className="inline-block bg-forest hover:bg-leaf text-white font-semibold py-2 px-6 rounded-lg transition-colors"
                    >
                        Tillbaka
                    </Link>
                </div>

                {/* Title */}
                <div className="bg-sage/20 py-8">
                    <div className="max-w-7xl mx-auto px-6">
                        <h1 className="font-heading text-4xl font-bold text-center text-charcoal tracking-wider">
                            Redigera Artlista
                        </h1>
                    </div>
                </div>

                {/* Dual List Container */}
                <div className="max-w-7xl mx-auto px-6 py-10">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-stretch">
                        {/* Left: All Species List */}
                        <div className="md:col-span-5">
                            <div className="bg-white rounded-lg border-2 border-sage shadow-lg h-[650px] flex flex-col">
                                <div className="p-6 border-b border-gray-200">
                                    <h2 className="font-heading text-2xl font-semibold text-center text-charcoal tracking-wider mb-4">
                                        Artlista
                                    </h2>
                                    <input
                                        type="text"
                                        placeholder="Sök arter"
                                        value={speciesSearch}
                                        onChange={(e) => setSpeciesSearch(e.target.value)}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-forest"
                                    />
                                </div>
                                <div className="flex-1 overflow-y-auto p-4">
                                    {!isPending && species && (
                                        <div className="space-y-2">
                                            {filteredSpecies?.map((x) => (
                                                <div
                                                    key={x.id}
                                                    onClick={() => handleSelectSpecies(x)}
                                                    className={`p-4 rounded-lg cursor-pointer transition-all ${
                                                        selectedSpecies.includes(x)
                                                            ? "border-2 border-leaf bg-sage/20"
                                                            : "border border-gray-300 hover:bg-gray-50"
                                                    }`}
                                                >
                                                    {x.name}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Center: Action Buttons */}
                        <div className="md:col-span-2 flex flex-col justify-center items-center gap-4">
                            <button
                                onClick={handleAddSpeciesToZone}
                                disabled={!selectedSpecies.length}
                                className={`w-40 py-3 px-6 rounded-lg font-semibold transition-colors ${
                                    selectedSpecies.length
                                        ? "bg-forest hover:bg-leaf text-white cursor-pointer"
                                        : "bg-gray-300 text-gray-500 cursor-not-allowed"
                                }`}
                            >
                                Lägg till →
                            </button>
                            {selectedAreaSpecies.length > 0 && (
                                <button
                                    onClick={handleRemoveAllSpeciesFromZone}
                                    className="w-40 py-3 px-6 rounded-lg font-semibold bg-red-700 hover:bg-red-800 text-white transition-colors"
                                >
                                    Ta bort
                                </button>
                            )}
                        </div>

                        {/* Right: Area Species List */}
                        <div className="md:col-span-5">
                            <div className="bg-white rounded-lg border-2 border-sage shadow-lg h-[650px] flex flex-col">
                                <div className="p-6 border-b border-gray-200">
                                    <h2 className="font-heading text-2xl font-semibold text-center text-charcoal tracking-wider mb-4">
                                        {areaName}
                                    </h2>
                                    <input
                                        type="text"
                                        placeholder="Sök arter i zonen"
                                        value={areaSpeciesSearch}
                                        onChange={(e) => setAreaSpeciesSearch(e.target.value)}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-forest"
                                    />
                                </div>
                                <div className="flex-1 overflow-y-auto p-4">
                                    {Array.isArray(areaSpecies) && areaSpecies.length > 0 ? (
                                        <div className="space-y-2">
                                            {filteredAreaSpecies?.map((speciesItem) => (
                                                <div
                                                    key={speciesItem.id}
                                                    onClick={() => handleSelectAreaSpecies(speciesItem)}
                                                    className={`p-4 rounded-lg cursor-pointer transition-all ${
                                                        selectedAreaSpecies.includes(speciesItem)
                                                            ? "border-2 border-leaf bg-sage/20"
                                                            : "border border-gray-300 hover:bg-gray-50"
                                                    }`}
                                                >
                                                    {speciesItem.name}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="text-gray-500 text-center mt-8">Inga arter funna i denna zon.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
